/*
 * @Description: framework constants
 * @Usage: 
 * @Author: richen
 * @Date: 2023-12-09 21:56:32
 * @LastEditTime: 2023-12-09 23:00:13
 * @License: BSD (3-Clause)
 * @Copyright (c): <richenlin(at)gmail.com>
 */

export const COMPONENT_SCAN = 'COMPONENT_SCAN';
export const CONFIGURATION_SCAN = 'CONFIGURATION_SCAN';
export const PRIORITY_KEY = 'PRIORITY_KEY';

// tslint:disable: no-irregular-whitespace
export const LOGO = `

┬┌─┌─┐┌─┐┌┬┐┌┬┐┬ ┬
├┴┐│ │├─┤ │  │ └┬┘
┴ ┴└─┘┴ ┴ ┴  ┴  ┴ 
-------------------------------------------
https://github.com/koatty
`;